import React from "react";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp } from "react-icons/fa";
import "./Contact.css";

function Contact() {
  const phoneNumber = "0533 730 87 79";
  const formattedPhone = "+905337308779";
  const whatsappNumber = "905337308779";
  const email = "erenotoyedekparca@gmail.com";
  const address =
    "Maltepe Mah. Yedikule Çırpıcı Yol Sk. Akınsal San. Sit. C Blok No:13 Topkapı - Zeytinburnu / İST.";
  const mapLink =
    "https://www.google.com/maps/dir//Maltepe,+Ak%C4%B1nsal+Sanayi+Sitesi+No:13+C+Blok,+34025+Zeytinburnu%2F%C4%B0stanbul/@41.0180093,28.8255252,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x14cabb629a1460e7:0xd00d0103520978e!2m2!1d28.907926!2d41.0180386?hl=tr&entry=ttu&g_ep=EgoyMDI1MDYyMy4yIKXMDSoASAFQAw%3D%3D";

  return (
    <div className="contact-container">
      <h2 className="contact-title">İletişim</h2>
      <p className="contact-subtitle">Bizimle aşağıdaki kanallardan iletişime geçebilirsiniz.</p>

      <div className="contact-card">
        <div className="contact-row">
          <div className="contact-label">Telefon:</div>
          <div className="contact-info">
            <a href={`tel:${formattedPhone}`} className="contact-link">
              <FaPhone /> {phoneNumber}
            </a>
          </div>
        </div>

        <div className="contact-row">
          <div className="contact-label">WhatsApp:</div>
          <div className="contact-info">
            <a
              href={`https://wa.me/${whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-button"
            >
              <FaWhatsapp /> WhatsApp'tan Yaz
            </a>
          </div>
        </div>

        <div className="contact-row">
          <div className="contact-label">E-posta:</div>
          <div className="contact-info">
            <a
              href={`mailto:${email}`}
              className="contact-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaEnvelope /> {email}
            </a>
          </div>
        </div>

        <div className="contact-row">
          <div className="contact-label">Adres:</div>
          <div className="contact-info">
            <p className="contact-address">{address}</p>
            <a
              href={mapLink}
              target="_blank"
              rel="noopener noreferrer"
              className="map-button"
            >
              <FaMapMarkerAlt /> Haritada Göster
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;